// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getAllDataSites = createAsyncThunk('appUsers/getAllDataSites', async (id) => {
  const response = await axios.get('https://apiv4dev2.opentlv.com/api/v3/user/sites/all', { params: { id} })
  return response.data
})

export const getDataSites = createAsyncThunk('appUsers/getDataSites', async params => {
  const response = await axios.get('https://apiv4dev2.opentlv.com/api/v3/user/sites/data', { params})
  return {
    params,
    data: response.data.data,
    totalPages: response.data.total
  }
})

export const addUserToSite = createAsyncThunk('appUsers/addUserToSite', async (group, { getState }) => {
  //  option.client_id = getState()
    console.log("addPrivilgeToGroup")
    
    group.user_id = getState().users.selectedUser.id
    
    
    await axios.post('https://apiv4dev2.opentlv.com/api/v3/user/addusertosite', group)
    //.wait dispatch(getGroupPrivilegesData(getState().groupPrivileges.params))
  
    //await d
  })


export const appUsersSlice = createSlice({
  name: 'appUsers',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllDataSites.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getDataSites.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
  }
})

export default appUsersSlice.reducer
